import DateTime from "../../../../src/components/tools/DateTime";
import * as React from 'react';
export default {
  DateTime,
  React
};